module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日期范围"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "alue-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.vdate),
      callback: function($$v) {
        _vm.vdate = $$v
      },
      expression: "vdate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入店名"
    },
    model: {
      value: (_vm.akeywords),
      callback: function($$v) {
        _vm.akeywords = $$v
      },
      expression: "akeywords"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入商品名称"
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getGoodsDataList()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n         \n        "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportloading),
      expression: "exportloading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "平台统计",
      "name": "goods_count"
    }
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.allListData,
        "stripe": "",
        "border": "",
        "height": _vm.wheight - 230
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "distributor_id",
        "label": "店铺id"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "店铺名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "office_area_name",
        "label": "大区名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_fee",
        "label": "实收/元"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "cost_fee",
        "label": "成本价/元"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "profit",
        "label": "毛利润/元"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "category_name",
        "label": "分类名称"
      }
    })], 1)]
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a65bd64a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a65bd64a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/datacube/platform.vue
// module id = 2898
// module chunks = 0